module.exports = __webpack_public_path__ + "static/img/vEight3.a7a2200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vEight3.png
// module id = MTd8
// module chunks = 2